import { SelectWithAll } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Form, SelectProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { getRestrictionProps } from "../../../../../tickets";
import { PathContext } from "../../../context/PathContext";
import { FormItemPath } from "../../../types/Config";

type Props = {};

export const RestrictionFieldSelect = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);
  const { thresholds, getRestrictionLabelByValue } = getRestrictionProps();

  const options: SelectProps["options"] = useMemo(
    () =>
      thresholds.map((threshold) => ({
        label: t(getRestrictionLabelByValue(threshold)),
        value: threshold,
      })),
    []
  );

  return (
    <Form.Item<FormItemPath<"priority">>
      name={[...path, "restriction"]}
      label={t("maintenance:ticket.create.config.priority.restriction.label")}
      initialValue={thresholds}
    >
      <SelectWithAll
        allLabel={t("maintenance:general.all")}
        options={options}
      />
    </Form.Item>
  );
});
